import { useNotify } from "../../hooks/use-notify";
import { COOKIE_ACCESS_ROLE } from "../../utils/storage-constants";

export const Preferences = ({
  preferences,
  setPreferences,
  onUpdate,
  accessData,
  setAccessData,
  showPopup,
  selectedPreference,
  setShowPopup,
  setSelectedPreference,
  getMediumProfile,
  getMediums,
}) => {
  const { toggleNotify } = useNotify();
  const CLASS_OPTIONS = ["6", "7", "8", "9", "10"];
  const SCHOOL_BASED_EXAMS = ["TN_STATE_BOARD", "ICSE", "CAIE", "CBSE"];
  const isSchoolCourse = SCHOOL_BASED_EXAMS.includes(selectedPreference?.title);
  const togglePreference = (id, title) => {
    const role = localStorage.getItem(COOKIE_ACCESS_ROLE);

    const isGuest = role === "guest";

    if (isGuest) {
      toggleNotify({
        type: "error",
        title: "No Active Subscription",
        description: "Please make payment and subscribe to continue.",
      });

      return;
    }

    // setPreferences((prev) =>
    //   prev.map((item) => {
    //     if (item.disabled) return item;

    //     return {
    //       ...item,
    //       enabled: item.id === id,
    //     };
    //   }),
    // );

    setSelectedPreference({ id, title });

    setAccessData({
      classGrade: "",
      medium: "",
    });

    setShowPopup(true);

    //  if (onUpdate) onUpdate(title);
  };

  const handleConfirmSelection = async () => {
    if (!accessData.medium) {
      toggleNotify({
        type: "error",
        title: "Validation",
        description: "Please select medium",
      });
      return;
    }

    if (!accessData.classGrade && isSchoolCourse) {
      toggleNotify({
        type: "error",
        title: "Validation",
        description: "Please select class",
      });
      return;
    }

    // setPreferences((prev) =>
    //   prev.map((item) => ({
    //     ...item,
    //     enabled: item.id === selectedPreference.id,
    //   })),
    // );

    setPreferences((prev) =>
      prev.map((item) => ({
        ...item,
        enabled: item.id === selectedPreference.id,
        classGrade:
          item.id === selectedPreference.id
            ? accessData.classGrade
            : item.classGrade,
        medium:
          item.id === selectedPreference.id ? accessData.medium : item.medium,
      })),
    );

    // // Existing API call
    // if (onUpdate) {
    //   await onUpdate(selectedPreference.title);
    // }

    setShowPopup(false);
  };

  return (
    <section className="settings-section">
      <div className="section-header">
        <h3>Your Competitive Exam Preferences</h3>
        <p>
          Choose the exams you want to prepare for. You can change this anytime.
        </p>
      </div>

      {/*  */}
      {showPopup && (
        <section className="access_popup_overlay">
          <section className="access_popup">
            <button className="close_btn" onClick={() => setShowPopup(false)}>
              ✕
            </button>

            <h2>Select Your Class</h2>

            <p className="popup_desc">
              Choose your grade and medium of instruction
            </p>

            {isSchoolCourse && (
              <div className="input_group">
                <label>Class/grade</label>

                <div className="custom_select">
                  <select
                    value={accessData.classGrade}
                    onChange={(e) =>
                      setAccessData((prev) => ({
                        ...prev,
                        classGrade: e.target.value,
                      }))
                    }
                  >
                    <option value="">Select Class</option>
                    {CLASS_OPTIONS.map((item) => (
                      <option key={item} value={item}>
                        {item}
                      </option>
                    ))}
                  </select>
                </div>
              </div>
            )}

            <div className="input_group">
              <label>Medium</label>

              <div className="custom_select">
                <select
                  value={accessData.medium}
                  onChange={(e) =>
                    setAccessData((prev) => ({
                      ...prev,
                      medium: e.target.value,
                    }))
                  }
                >
                  <option value="">Select Medium</option>

                  {getMediums?.map((item) => (
                    <option key={item} value={item}>
                      {item}
                    </option>
                  ))}
                </select>
              </div>
            </div>

            <div className="popup_actions">
              <button
                className="cancel_btn"
                onClick={() => setShowPopup(false)}
              >
                Cancel
              </button>

              <button className="confirm_btn" onClick={handleConfirmSelection}>
                Confirm Selection
              </button>
            </div>
          </section>
        </section>
      )}

      <div className="settings-card">
        {preferences && preferences.length > 0 ? (
          <section className="preferences-list">
            {preferences.map((item) => (
              <section
                key={item.id}
                className={`preference-item ${item.enabled ? "active" : ""} ${item.disabled ? "disabled" : ""}`}
              >
                <section className="left">
                  <img src={item.icon} alt={item.title} className="icon" />
                  <section className="text">
                    <h4>{item.title}</h4>
                    <span>{item.desc}</span>
                  </section>
                </section>

                <label className="switch">
                  <input
                    type="checkbox"
                    checked={item.enabled}
                    disabled={item.disabled}
                    onChange={() => {
                      getMediumProfile({ title: item?.title });
                      togglePreference(item.id, item.title);
                    }}
                  />
                  <span className="slider" />
                </label>
              </section>
            ))}
          </section>
        ) : (
          <div className="empty-preferences">
            <p>No exam preferences available.</p>
          </div>
        )}
      </div>
    </section>
  );
};
